
import React from 'react';
import Plausible from 'plausible-tracker';

class PageTracking extends React.Component {

    componentDidMount() {
        if (process.env.REACT_APP_LOCAL !== 'true') {
            console.log('Plausible - initialized')

            const plausible = Plausible({
                domain: 'naki-vineyard.hfbiz.cz',
                hashMode: true
            });
            plausible.enableAutoPageviews();
        } else {
            console.log('Plausible - not initialized (local development)')
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

export default PageTracking;
